
// import request from '@/utils/request'
import request, { post, get } from '@/utils/request'
import { ouchnCustom } from "@/service"

// 乐学下拉分类
export function GetTreeSelectByType(query){
  return request({
    url:ouchnCustom + '/web/goods/getTreeSelectByType',
    method:'get',
    params: query
  })
}

// 首页banner
export function GetBannerList(query){
  return request({
    url:ouchnCustom + '/device/api/homePage/bannerList',
    method:'get',
    params: query
  })
}

// 正版书增值服务课程 —— 2023版  首页四套卷
// export function SelectOclexueResource(query){
//   return request({
//     url:ouchnCustom + '/device/api/OcLexueHome/selectOclexueResource',
//     method:'post',
//     params: query
//   })
// }
export const SelectOclexueResource = (data) => post(ouchnCustom + '/device/api/OcLexueHome/selectOclexueResource', data, { disableToken: false })

// 书系列表
export function GetBooksList(data) {
	return request({
		url: ouchnCustom + '/device/api/ocLexueResourceBook/selectOclexueResourceBook',
		method: 'post',
		data
	})
}
// 书系课程，试卷总数
export function selectOcLexueResourceBookCourseById(data) {
	return request({
		url: ouchnCustom + '/device/api/ocLexueResourceBook/selectOcLexueResourceBookCourseById?goodsId='+data,
		method: 'get',
	})
}
// 乐学模块增加浏览量
export function UpdateViewerNumber(data) {
	return request({
		url: ouchnCustom + '/device/read/updateViewerNumber',
		method: 'get',
		params:data
	})
}
// 书系详情
export function selectOclexueResourceBookById(data) {
	return request({
		url: ouchnCustom + '/device/api/ocLexueResourceBook/selectOclexueResourceBookById',
		method: 'post',
		params:data
	})
}
// 绑定乐学授权码
export function BoundLexueCode(data) {
	return request({
		url: ouchnCustom + '/device/lexueCode/boundLexueCode',
		method: 'POST',
		data
	})
}
// 获取用户错题本
export function GetWrongQuestionList(data) {
	return request({
		url: ouchnCustom + '/device/paper/selWrongQuestionList',
		token: true,
		method: 'post',
		data
	})
}
// 获取用户错题本V2
export function GetWrongQuestionListV2(data) {
	return request({
		url: ouchnCustom + '/device/paper/selWrongQuestionListV2',
		token: true,
		method: 'post',
		data
	})
}
// 根据商品id查询错题记录
export function selWrongQuestionListByGoodId(data) {
	return request({
		url: ouchnCustom + '/device/paper/selWrongQuestionListByGoodId',
		token: true,
		method: 'post',
		data
	})
}
// 获取错题本题目信息
export function gotQuestionExercise(data) {
	return request({
		url: ouchnCustom + '/device/paper/wrongQuestionExercise',
		token: true,
		method: 'post',
		data
	})
}
// 删除用户错题本
export function delWrongQuestion(data) {
	return request({
		url: ouchnCustom + '/device/paper/delWrongQuestion',
		token: true,
		method: 'post',
		data
	})
}
// 更新用户学习时长
export function updateTheLearningTime(data) {
	return request({
		url: ouchnCustom + '/device/read/updateOcDownloadReadingForLuxue',
		contentType:"application/x-www-form-urlencoded",
		token: true,
		method: 'post',
		data
	})
}

// 获取乐学商品当天学习时长
export function getLexueReadTime(data) {
	return request({
		url: ouchnCustom + '/device/read/getLexueReadTime',
		token: true,
		method: 'get',
		params:data
	})
}
// 获取调用阅读时长接口频率
export function selectTimeParameter() {
	return request({
		url: ouchnCustom + '/device/read/selectTimeParameter',
		token: true,
		method: 'get',
	})
}
// 获取用户试题数量
export function GetQuestionIsUse(data) {
	return request({
		url: ouchnCustom + '/device/paper/getNumberQuestionIsUse',
		token: true,
		method: 'get',
		params:data
	})
}
// 更新用户乐学模块学习时长
export function saveProgress(data) {
	return request({
		url: ouchnCustom + '/device/read/updateOcDownloadReadingForLuxue',
		contentType:"application/x-www-form-urlencoded",
		token: true,
		method: 'post',
		params:data
	})
}
// 更新用户乐学模块播放记录
export function updateLexuePlayedbackSchedule(data) {
	return request({
		url: ouchnCustom + '/device/read/updateLexuePlayedbackSchedule',
		token: true,
		method: 'post',
		data
	})
}
// 更新用户乐学模块播放记录
export function getUserLastRead(goodsId) {
	return request({
		url: ouchnCustom + '/device/read/getUserLastRead?goodsId='+goodsId,
		token: true,
		method: 'get',
	})
}

// 新增考试记录
export function saveAnswerPaperRecordApi(data) {
	return request({
		url: ouchnCustom + '/record/saveAnswerPaperRecord',
		token: true,
		method: 'POST',
		data
	})
}

// 查询试卷详情信息（试卷考试）
export function getTestPaperExamInfoByIdApi(data) {
	return request({
		url: ouchnCustom + '/record/getTestPaperExamInfoById',
		token: true,
		method: 'GET',
		params:data
	})
}

// 新增答题记录
export function addAnsQuesRecordApi(data) {
	return request({
		url: ouchnCustom + '/record/addAnsQuesRecord',
		token: true,
		method: 'POST',
		data
	})
}

// 提交考试记录
export function submitAnswerPaperRecordApi(data, token) {
	return request({
		url: ouchnCustom + '/record/submitAnswerPaperRecord',
		token: true,
		method: 'POST',
		data
	})
}